import {
    ERROR_ALERT_PUSH,
    ERROR_LIST_CLEAR,
    INFO_ALERT_PUSH,
    INFO_LIST_CLEAR,
    REINITIATE_DEVICE,
    SUBMIT_DEVICE_DATA
} from "../../constant/reducerConstants";
import {AppError, AppInfo, withCustomDescription} from '../../constant/appAlerts';

const initialState = {
    errorMap: {},
    infoMap: {}
};

export function alertReducer(state = initialState, action) {
    let completed, alert;
    switch (action.type) {
        case ERROR_ALERT_PUSH:
            return {...state, errorMap: {...state.errorMap, ...action.error}};
        case ERROR_LIST_CLEAR:
            return {...state, errorMap: initialState.errorMap};
        case INFO_ALERT_PUSH:
            return {...state, infoMap: {...state.infoMap, ...action.info}};
        case INFO_LIST_CLEAR:
            return {...state, infoMap: initialState.infoMap};
        case SUBMIT_DEVICE_DATA:
            completed = action.data.completedDevices.length;
            let total = completed + action.data.errorDevices.length;
            let deviceEpNumbersReinitiated = action.data.completedDevices
                .filter(device => device.metadata.hasReinitiated)
                .map(device => device.epNumber)
                .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
            let reinitiatedAlert = deviceEpNumbersReinitiated.length > 0 ?
                ' EP [' + deviceEpNumbersReinitiated.toString() + ']' +
                ' had an open provisioning task which was canceled in favor of the new one.'
                : '';
            alert = withCustomDescription(
                AppInfo.SUBMIT_COMPLETE,
                completed + '/' + total + ' device(s) submitted successfully.' + reinitiatedAlert);
            return {...state, infoMap: {...state.infoMap, ...alert}};
        case REINITIATE_DEVICE:
            completed = action.data.completedDevices.length;
            if (completed > 0) {
                alert = withCustomDescription(AppInfo.REINITIATE_COMPLETE, 'Reinitiated provisioning successfully.')
                return {...state, infoMap: {...state.infoMap, ...alert}};
            }

            let errorReason = action.data.errorDevices[0].metadata.errorMap ? ' with error: ' + Object.values(action.data.errorDevices[0].metadata.errorMap)[0] : "";
            alert = withCustomDescription(AppError.REINITIATE_FAILED, 'Unable to reinitiate provisioning' + errorReason + '.')
            return {...state, errorMap: {...state.errorMap, ...alert}};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/reducer/alertReducer.js